import React, { useEffect } from 'react'
import { View, TouchableOpacity, Text, Image, StyleSheet } from "react-native"
import { FONT_STYLE, GIFT_TYPE } from "../../dataSchema/const"
import { DATA_SERVICE } from "../../dataSchema/DataService";

const ResultPopUpWithGifts = ({ gifts, requestClose, isZmp }) => {
  useEffect(()=>{
    console.log('[ResultPopUpWithGifts] mounted, isZmp=', isZmp)
  }, [isZmp])

  const giftStringFormat = (gift) => {
    if (gift.type === GIFT_TYPE.BRAND_POINT || gift.type === GIFT_TYPE.VUI_POINT) {
      return `${gift.quantity} ${gift.type === GIFT_TYPE.VUI_POINT ? 'Điểm VUI' : gift.currencyName}`
    }
    if (gift.type === 'VOUCHER') {
      return `${gift.offerName || ''}`
    }
    return ``;
  }

  const giftFormat = () => {
    if (gifts.length >= 2) {
      return `${giftStringFormat(gifts[0])} và ${giftStringFormat(gifts[1])} ${gifts.length - 2 > 0 ? `và ${gifts.length - 2} ưu đãi khác` : ''}`
    } else if (gifts.length > 0 && gifts.length < 2) {
      return `${giftStringFormat(gifts[0])}`
    } else {
      return ``
    }
  }

  return (
    <View style={styles.popup}>
      <Text style={styles.popupText}>{DATA_SERVICE.data.mobileForm.giftPackages.thanksContent || 'Quà tặng khảo sát'}</Text>
      <Image style={styles.image} source={require('../../assets/gift-box.png')}></Image>
      {isZmp ? (
        <Text style={styles.contentText}>{'Hãy trở về TAPTAP Mini app để tận hưởng thêm nhiều niềm vui và quà tặng đang chờ bạn!'}</Text>
      ) : (
        <Text style={styles.contentText}>
          {DATA_SERVICE.data.mobileForm.giftPackages.thanksContent ? DATA_SERVICE.data.mobileForm.giftPackages.thanksContent : 'Cảm ơn bạn đã dành thời gian cho chúng tôi\nChúc bạn và gia đình một ngày tốt lành!'}
          {gifts && gifts.length ? <Text style={styles.item}>{'\n' + giftFormat()}</Text> : null}
        </Text>
      )}

      {!isZmp && (
        <TouchableOpacity
          style={styles.closeButton}
          onPress={requestClose}
        >
          <Text style={styles.closeButtonText}>Đóng</Text>
        </TouchableOpacity>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  image: {
    width: 78,
    height: 84,
    marginTop: 24
  },
  popup: {
    width: 343,
    height: 330,
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  popupText: {
    fontSize: 22,
    fontFamily: FONT_STYLE.BOLD,
    width: '100%',
    textAlign: 'center',
    marginTop: 24
  },
  item: {
    fontSize: 16,
    fontFamily: FONT_STYLE.BOLD,
  },
  contentText: {
    fontSize: 14,
    fontFamily: FONT_STYLE.MEDIUM,
    textAlign: 'center',
    width: '100%',
    marginTop: 25
  },
  closeButton: {
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: '#888888',
    width: '90%',
    position: 'absolute',
    bottom: 25
  },
  closeButtonText: {
    color: '#000000',
    fontSize: 16,
    fontFamily: FONT_STYLE.BOLD,
    textAlign: 'center'
  },
})
export default ResultPopUpWithGifts